import { lazy, Suspense } from "react";

import { useFirstOpenLatch } from "../lib/hooks/use_first_open_latch";
import { useUIStore } from "../store/ui";

// The chunk loads on first open, so the login screen's cold load does
// not carry it.
const SettingsBottomSheet = lazy(() =>
  import("../theme/skins/default/modals/SettingsBottomSheet").then((m) => ({
    default: m.SettingsBottomSheet,
  })),
);

/** The settings sheet for the screens before a table — login and
 *  lobby. The game mounts its own. */
export function EntrySettingsSheet(): JSX.Element | null {
  const everOpened = useFirstOpenLatch(useUIStore((s) => s.settingsPanelOpen));
  if (!everOpened) return null;
  return (
    <Suspense fallback={null}>
      <SettingsBottomSheet />
    </Suspense>
  );
}
